import React from 'react';
import { connect } from 'react-redux';
import { getTranslate, LocalizeState } from 'react-localize-redux';
import UserHelper from 'infrastructure/UserHelper';
import { compose } from 'recompose';

import routes from 'library/Routes';
import { Link, Paper, Typography, SnackbarContent } from '@material-ui/core';
import { withStyles, WithStyles, Theme } from '@material-ui/core/styles';
import { GuestBookingForm } from './GuestBookingForm';
import { GuestBookingForm2 } from './GuestBookingForm2';
import { AuthorizedBookingForm } from './AuthorizedBookingForm';
import { Studio, User } from '../../types';

interface ClientAttendance {
  ownerId: string;
  studioClientId: string;
}

interface ReduxState {
  locale: LocalizeState;
  user: User;
}

interface BookingClassInfoFormProps extends WithStyles<typeof styles> {
  clientAttendance?: ClientAttendance;
  owner: User;
  studio: Studio;
  user: User;
  translate: (key: string) => string;
}

interface BookingClassInfoFormState {
  clientAttendance?: ClientAttendance;
}

// Component
class BookingClassInfoForm extends React.Component<BookingClassInfoFormProps, BookingClassInfoFormState> {
  constructor(props: BookingClassInfoFormProps) {
    super(props);
    this.state = {
      clientAttendance: props.clientAttendance,
    };
  }

  render() {
    if (this.state.clientAttendance) {
      return this.renderClientAttendanceLink(this.state.clientAttendance);
    }
    const { classes, user } = this.props;
    const GuestForm = this.props.studio.bookClassInfoWithPin ? GuestBookingForm : GuestBookingForm2;

    return (
      <Paper className={classes.root} elevation={1}>
        {UserHelper.isOwnerClient(user, this.props.owner._id) ? (
          <AuthorizedBookingForm {...this.props} />
        ) : (
          <GuestForm
            {...this.props}
            setAttendance={(clientAttendance: ClientAttendance) => this.setState({ clientAttendance })}
          />
        )}
      </Paper>
    );
  }

  renderClientAttendanceLink = (clientAttendance: ClientAttendance) => {
    return (
      <Paper className={this.props.classes.paper}>
        <SnackbarContent
          message={
            <Typography align="center">
              {this.props.translate('manageRegistration.alreadySignedUpToTheClass')}
              <br />
              <Link
                href={routes.studioClientClasses({
                  ownerId: clientAttendance.ownerId,
                  studioClientId: clientAttendance.studioClientId,
                })}
              >
                {this.props.translate('common.myClasses')}
              </Link>
            </Typography>
          }
        />
      </Paper>
    );
  };
}

// Styles
const styles = (theme: Theme) => ({
  root: {
    margin: `0 auto`,
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
  },
});

export default compose(
  withStyles(styles),
  connect((state: ReduxState) => ({
    translate: getTranslate(state.locale),
    user: state.user,
  }))
)(BookingClassInfoForm);
